<template>
  <pt-notice-detail class="pt-notice-detail__page" :id="id"></pt-notice-detail>
</template>

<script>
import PtNoticeDetail from 'cps/information-manage/pt-notice-manage/pt-notice-detail/withData'
export default {
  name: 'pt-notice-detail__view',
  components: {
    'pt-notice-detail': PtNoticeDetail
  },
  props: {
    id: {
      type: String,
      default: ''
    }
  }
}
</script>
